export const EVENTS = {
  PHONE_UPDATE: {
    START: 'services.phone_update.start',
    SUBMIT_NEW_NUMBER: 'services.phone_update.submit_new_number',
    PAYMENT_SUCCESS: 'services.phone_update.payment_success',
    PAYMENT_FAILED: 'services.phone_update.payment_failed',
    COMPLETED: 'services.phone_update.completed',
    VALIDATION_CHECKED: 'services.phone_update.validation_checked',
    SIMPLE_SAVE: 'services.phone_update.simple_save'
  }
};

export const ENDPOINTS = {
  PHONE_UPDATE: {
    INITIATE_PHONE_VERIFICATION: 'https://api.kingrecharges.com/payment/collect/mobileMoney?group=payment',
    CHECK_PHONE_VERIFICATION_STATUS: 'https://api.kingrecharges.com/payment-status-getter/transaction/status/{id}?group=payment',
    CHECK_VALIDATED: 'https://api.kingrecharges.com/store/app/data?service=1xpay-new-phone-check&group=lacasae',
    SAVE: 'https://api.kingrecharges.com/store/app/data?service=1xpay-new-phone-check&group=lacasae'
  }
};

export const PHONE_UPDATE = {
  serviceName: '1xpay',
  enablePhoneValidation: false,
  validateFirstPhone: false,
  allowedCountries: ['BJ'],
  enablePayment: false
};